import React, { useImperativeHandle, useState } from 'react'
import { useFormik, FormikProvider, FieldArray } from 'formik'

// components
import ActionButton from '../../../../../components/buttons/ActionButton/ActionButton.component';
import FormSectionHeader from '../../../../../components/forms/FormSectionHeader/FormSectionHeader.component';
import FormDataPoint from '../../../../../components/forms/FormDataPoint/FormDataPoint.component';
import AsyncSelectField from '../../../../../components/forms/AsyncSelectField/AsyncSelectField.component';
import EquipmentRequestItem from '../../../../../components/forms/lists/EquipmentRequestItem/EquipmentRequestItem.component';
import AddEquipmentRequestItemInput from '../../../../../components/forms/lists/AddEquipmentRequestItemInput/AddEquipmentRequestItemInput.component';

// mui
import { Grid } from '@mui/material';

// queries
import { GET_ALL_EQUIPMENT_FOR_SELECT_FIELD } from '../../../../../graphql/equipment/equipment.queries';

const AddItemsToRequest = React.forwardRef(({ prefillData = null, errors }, ref) => {
    useImperativeHandle(ref, () => ({
        getData: () => { return formik.values }
    }))
    const [ selectedEquipment, setSelectedEquipment ] = useState(null)

    const formik = useFormik({
        initialValues: prefillData ? {...prefillData} : {
            items: [],
            equipment: []
        }
    });

    return (<FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
            <FormDataPoint label='Job' value={prefillData['job'].name} />
            <FormDataPoint label='Requested By' value={prefillData ? `${prefillData['requestedBy'].firstName} ${prefillData['requestedBy'].lastName}` : null} />

            <FormSectionHeader text='Equipment' />

            <FieldArray
                name='equipment'
                render={() => (
                    <div>
                        {
                            formik.values.equipment.map((item, index) => {
                                return (<EquipmentRequestItem 
                                    key={`equipmentRequestItem-${item.equipment.id}-${index}`}
                                    title={item.equipment.name}
                                    subTitle={`Requested: ${item.requestedQuantity}`}
                                />)
                            })
                        }
                    </div>
                )}

            />

            <FieldArray
                name='items'
                render={({remove, push}) => (
                    <div>
                        <FormSectionHeader text='New Items' />
                        <Grid container spacing={2} alignItems='center'>
                            <Grid item xs={10}>
                                <AsyncSelectField 
                                    id="equipmentSearch"
                                    value={formik.values.equipmentSearch}
                                    placeholder="Select Equipment..."
                                    onChange={value => {
                                        setSelectedEquipment(value.data)
                                        formik.setFieldValue('equipmentSearch', value.value)
                                    }}
                                    query={{
                                        query: GET_ALL_EQUIPMENT_FOR_SELECT_FIELD,
                                        rules: {
                                            loopField: 'allEquipment',
                                            label: ['sku', 'name'],
                                            value: 'id',
                                            groupBy: 'category.name'
                                        }
                                    }}
                                    grouped
                                    required={false}
                                    
                                />
                            </Grid>
                            <Grid container item xs={2}>
                                <ActionButton sx={{ width: "100%", marginBottom: 2 }} label='Add' disabled={selectedEquipment == null} onClick={(e) => {
                                    e.preventDefault();
                                    push({...selectedEquipment, requestedQuantity: ''})
                                }} />
                            </Grid>
                        </Grid>

                        {
                            formik.values.items.map((item, index) => {
                                return (<AddEquipmentRequestItemInput 
                                    key={index}
                                    prefix={`items.${index}`}
                                    handleChange={formik.handleChange}
                                    title={item.name}
                                    subTitle={`Qty: ${item.quantity}`}
                                    requestedQuantity={item.requestedQuantity}
                                    handleRemove={(e) => {
                                        e.preventDefault()
                                        remove(index)
                                    }}
                                    errors={errors['items'].length > index ? errors['items'][index] : {}}
                                />)
                            })
                        }
                    </div>
                )}
            />
        </form>
    </FormikProvider>)
})

export default AddItemsToRequest